export const common = {
  methods: {
    getAnchor () {
      let currentUrl = document.URL
      let data = currentUrl.split('#')
      return data.length > 1 ? data[1] : null
    }
  }
}
